<template>
    <div class="tariff-group">
        <FormRadioTariffCard
            v-for="option in options"
            :key="option.value"
            :label="option.label"
            :value="option.value"
            :modelValue="modelValue"
            :name="name"
            :type="option.type"
            :duration="option.duration"
            :durationDescription="option.durationDescription"
            :costs="option.costs"
            @update:modelValue="$emit('update:modelValue', $event)"
        />
    </div>
</template>

<script setup>
import FormRadioTariffCard from "./FormRadioTariffCard.vue";

defineProps({
    options: {
        type: Array,
        required: true,
    },
    name: {
        type: String,
        required: true,
    },
    modelValue: {
        type: [String, Number],
        required: true,
    },
    vertical: {
        type: Boolean,
        default: false,
    },
})
</script>

<style lang="scss" scoped>
@use "../../css/variables";

.tariff-group {
    display: grid;

    // grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    grid-template-columns: 1fr;
    gap: 1.5rem;
    margin-block: 2rem;
    justify-content: center;

    @media (width > variables.$sm) {
        grid-template-columns: 1fr 1fr;
    }

    @media (width > variables.$md) {
        grid-template-columns: 1fr 1fr 1fr;
    }

    @media (width > variables.$lg) {
        grid-template-columns: repeat(4, 210px);
    }
}
</style>